import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {
    Container,
    Grid,
    useTheme,
    useMediaQuery,
    Box,
    Tabs,
    Tab,
} from '@mui/material';

import MainMenu from "../../core/mainMenu";
import {selectCourses} from "../../../store/course/selectors";
import courseActions from '../../../store/course/actions';
import attestationActions from '../../../store/attestation/actions';
import {Course} from "../../../common/course";
import APP_URLs from "../../../consts/url";
import CourseCard from '../../core/courseCard';
import AttestaionCard from '../../core/attestationCard';
import {selectAttestations} from "../../../store/attestation/selectors";
import {Attestation} from "../../../common/attestsation";

type Props = {
    courses: Course[],
    fetchCourses: Function,
    fetchAttestations: Function,
    attestations: Attestation[],
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
  
const TabContent = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
const View = ({
    courses,
    fetchCourses,
    fetchAttestations,
    attestations,
}: Props) => {
    const [hoveredCourseIndex, setHoveredCourseIndex] = useState<number>(-1);
    const [tabValue, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };
    const theme = useTheme();
    const {t: translate, i18n: languageCtx} = useTranslation();
    const [tabLabels, setTabLabes] = useState<string[]>([translate('translation:myCourses')]);
    //@ts-expect-error
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
    useEffect(() => {
        fetchCourses();
        fetchAttestations();
    }, []);

    useEffect(() => {
        if (!attestations.length || tabLabels.length > 1) {
            return;
        }
        setTabLabes([...tabLabels, 'Мои Аттестации']);
    }, [attestations]);
    if (!courses || !courses.length) {
        return null;
    }
    return (
        <>
            <MainMenu />
            <Container sx={{pt: 2}}>
                <Grid container>
                    <Grid xs={12} item>
                        <Box sx={{ borderBottom: 1, borderColor: '#ccc' }}>
                            <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                                {tabLabels.map((tab: string) => (
                                    <Tab key={tab} label={tab} />
                                ))}
                            </Tabs>
                        </Box>
                        <TabContent value={tabValue} index={0}>
                            <Grid container>
                                {courses.map((course, index) => (
                                    <Grid
                                        key={index}
                                        xs={12}
                                        item
                                        component={Link}
                                        to={`${APP_URLs.COURSE}/${course.id}`}
                                        sx={{
                                            textDecoration: 'none',
                                            mb: 2
                                        }}
                                    >
                                        <CourseCard 
                                            elevation={hoveredCourseIndex === index ? 3 : 1}
                                            course={course}
                                            onMouseEnterFn={() => setHoveredCourseIndex(index)}
                                            onMouseLeaveFn={() => setHoveredCourseIndex(-1)}
                                            type={isSmallScreen ? 'image' : 'card'}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </TabContent>
                        <TabContent value={tabValue} index={1}>
                            <Grid container>
                                {attestations.map((attestation, index) => (
                                    <Grid item key={index} xs={12}>
                                        <AttestaionCard attestation={attestation}></AttestaionCard>
                                    </Grid> 
                                ))}
                            </Grid>
                        </TabContent>
                    </Grid>
                </Grid>
            </Container>
        </>
    ) 
}

//@ts-ignore
const mapStateToProps = (state) => { 
    return {
        courses: selectCourses(state),
        attestations: selectAttestations(state),
    }
}

//@ts-expect-error
const dispatchProps = (dispatch) => ({
    fetchCourses: bindActionCreators(courseActions.fetchCourses, dispatch),
    fetchAttestations: bindActionCreators(attestationActions.fetchAttestations, dispatch)
})

export default connect(mapStateToProps, dispatchProps)(View);